import PropTypes from 'prop-types';
import Loader from '@/components/loader/loader-component';
import { Col, Row } from '@/components/grid/grid-component';
import Input from '@/components/react-hook-form-inputs/input/input-component';
import PhoneInputComponent from '@/components/react-hook-form-inputs/input/phone-input/phone-input-component';
import {
  cellphoneNumberRegex,
  emailRegex,
  requiredValidationMessage,
} from '@/utils/validations';

/**
 * @param {object} props - The props object
 * @param {boolean} props.loading - Indicates if the component is loading
 * @returns {JSX.Element} The rendered component
 */
const AccountProfileForm = ({ loading }) => {
  if (loading) {
    return (
      <Row>
        <Loader loading />
      </Row>
    );
  }
  return (
    <Row>
      <Col sm={12} md={12} lg={6} xl={6} xxl={6}>
        <Input
          label="First Name"
          placeholder="First Name"
          name="first_name"
          registerOptions={{
            required: requiredValidationMessage,
          }}
        />
      </Col>
      <Col sm={12} md={12} lg={6} xl={6} xxl={6}>
        <Input
          label="Last Name"
          placeholder="Last Name"
          name="last_name"
          registerOptions={{
            required: requiredValidationMessage,
          }}
        />
      </Col>
      <Col sm={12} md={12} lg={6} xl={6} xxl={6}>
        <Input
          label="Email Address"
          placeholder="Email Address"
          name="email"
          disabled
          registerOptions={{
            validate: (value) => {
              let errorMessage = null;
              emailRegex.forEach((rule) => {
                if (!rule.pattern.test(value)) {
                  errorMessage = rule.message;
                }
              });
              return errorMessage || true;
            },
          }}
        />
      </Col>
      <Col sm={12} md={12} lg={6} xl={6} xxl={6}>
        <PhoneInputComponent
          name="contact_number"
          registerOptions={{
            validate: (value) => {
              let errorMessage = null;
              cellphoneNumberRegex.forEach((rule) => {
                if (!rule.pattern.test(value)) {
                  errorMessage = rule.message;
                }
              });
              return errorMessage || true;
            },
          }}
        />
      </Col>
    </Row>
  );
};

AccountProfileForm.propTypes = {
  loading: PropTypes.bool.isRequired,
};

export default AccountProfileForm;
